import AppRecord from './AppRecord.js'

class ContactInformation extends AppRecord {
  get _contactables(){
    return {
      'Person': 'people',
      'Entity': 'entities',
    }
  }
  get contactable(){
    if(!this.contactable_id){
      return {}
    }
    return this.constructor.employeeStore[this._contactables[this.contactable_type]].find(owner=>owner.id === this.contactable_id)
  }
  set contactable(object){
    this.contactable_id = object.id
    if(object.type === 'Entity'){
      this.contactable_type = 'Entity'
    } else {
      this.contactable_type = 'Person'
    }
  }
  get people(){
    if((this.contactable_type === 'Person') && this.contactable){
      return [this.contactable]
    } else if((this.contactable_type === 'Entity')  && this.contactable) {
      return this.contactable.people
    } else {
      return []
    }
  }
}

export default ContactInformation
